import './css/Services.css'
function Services() {
  return (
    <div>
      <br/> <br/> <br/>
<h1> HOW OUR SERVICES WORK</h1>
<h4> At Doddamani Tech solutions, we understand that flexibility and convenience are crucial for our clients. Therefore, we offer a hybrid model that combines both online and offline interactions to provide the best possible service. Here’s a detailed breakdown of how our services work</h4>
<h3> Initial Consultation </h3>
<div className='two-flex'>
<div>
<h2> Online</h2>
<ul className='layer4-ul'>
  <li>
  <b> Contact and Inquiry: </b> Clients can reach out to us through our website, email, or social media channels.
  </li>
  <li> <b> Virtual Meetings: </b> We arrange an initial virtual consultation via Zoom, Skype, or any preferred video conferencing tool to understand your business needs, goals, and current challenges.</li>
</ul>
</div>
<div>
<h2> Offline</h2>
<ul className='layer4-ul'>
  <li>
 <b> In-Person Meetings: </b>  For clients who prefer face-to-face interactions, we can schedule an in-person meeting at your business location or our office.
  </li>
  </ul>
</div>
</div>




<h3>Custom eCommerce Solutions</h3>
<div className='two-flex'>
<div>
<h2> Online</h2>
<ul className='layer4-ul'>
  <li>
  <b> Project Planning:  </b>Our team conducts comprehensive online workshops and brainstorming sessions to plan your eCommerce project.

  </li>
  <li> <b>Design and Development : </b> We provide regular updates through project management tools like Trello, Asana, or Basecamp, and conduct virtual reviews to ensure the project aligns with your vision</li>
</ul>
</div>
<div>
<h2> Offline</h2>
<ul className='layer4-ul'>
  <li>
  <b>Site Visits and Evaluations :</b> If necessary, our experts can visit your business premises to gain a deeper understanding of your operations and integrate offline elements seamlessly into your online store.

  </li>
  </ul>
</div>
</div>



<h3>Training and Support</h3>
<div className='two-flex'>
<div>
<h2> Online</h2>
<ul className='layer4-ul'>
  <li>
  <b> Webinars and Online Training: </b>  We offer comprehensive online training sessions to educate your team on managing your eCommerce platform, digital marketing strategies, and basic coding skills.
  </li>
  <li> <b>24/7 Support: </b>Our support team is available around the clock through chat, email, or phone to address any issues or queries</li>
</ul>
</div>
<div>
<h2> Offline</h2>
<ul className='layer4-ul'>
  <li>
  <b>On-Site Training: </b>For hands-on learning, our experts can conduct on-site training sessions to ensure your team is fully equipped to handle your new eCommerce platform.
  </li>
  <li> <b> Workshops and Seminars:</b> We periodically organize offline workshops and seminars on the latest trends in eCommerce and digital marketing.</li>
  </ul>
</div>
</div>






<h3>Digital Marketing Strategies</h3>
<div className='two-flex'>
<div>
<h2> Online</h2>
<ul className='layer4-ul'>
  <li>
  <b> Strategy Development: </b> Our digital marketing experts will work with you online to develop customized marketing strategies that suit your business goals.
  </li>
  <li> <b>Campaign Management: </b>We manage and monitor your digital marketing campaigns remotely, providing you with regular reports and insights.
  </li>
</ul>
</div>
<div>
<h2> Offline</h2>
<ul className='layer4-ul'>
  <li>
  <b>Local Marketing Initiatives: </b>We can help you implement offline marketing strategies like local events, flyers, and direct mail campaigns to complement your online efforts.
  </li>
  <li> <b> Workshops and Seminars:</b> We periodically organize offline workshops and seminars on the latest trends in eCommerce and digital marketing.</li>
  </ul>
</div>
</div>



<h3>Ongoing Maintenance and Updates</h3>
<div className='two-flex'>
<div>
<h2> Online</h2>
<ul className='layer4-ul'>
  <li>
  <b> Regular Check-ins: </b> We conduct regular online check-ins to review the performance of your eCommerce site and implement necessary updates
  </li>
  <li> <b>Remote Troubleshooting: </b>Our technical team is always ready to fix any issues remotely to ensure your site runs smoothly
  </li>
</ul>
</div>
<div>
<h2> Offline</h2>
<ul className='layer4-ul'>
  <li>
  <b>Periodic On-Site Visits: </b>For critical updates or major issues, we can arrange on-site visits to ensure everything is in optimal working condition
  </li>
  <li> <b> Workshops and Seminars:</b> We periodically organize offline workshops and seminars on the latest trends in eCommerce and digital marketing.</li>
  </ul>
</div>
</div>






<h3>Extra Service: Training in Coding and Business Management</h3>
<div className='two-flex'>
<div>
<h2> Online</h2>
<ul className='layer4-ul'>
  <li>
  <b> Coding Bootcamps: </b> We offer online coding bootcamps tailored to different skill levels, from beginner to advanced, focusing on languages and tools relevant to eCommerce
  </li>
  <li> <b>Business Management Courses: </b>Our online courses cover essential topics like business strategy, financial management, and operations to help you run your business more efficiently.

  </li>
</ul>
</div>
<div>
<h2> Offline</h2>
<ul className='layer4-ul'>
  <li>
  <b>In-Person Coding Classes: </b>For a more interactive learning experience, we conduct in-person coding classes and workshops
  </li>
  <li> <b> Business Seminars:</b> We organize offline seminars and networking events where you can learn from industry experts and connect with other business owners</li>
  </ul>
</div>
</div>

<h3> By offering a hybrid model of online and offline services, Doddamani Tech solutions ensures that we can meet your needs in the most effective and convenient way possible. Whether you prefer the flexibility of online interactions or the personal touch of offline meetings, we are committed to providing the support you need to thrive in the digital marketplace. </h3>
    </div>
  )
}

export default Services
